module.exports = __webpack_public_path__ + "img/cycle_g.f1071847.png";